const styles = {
    mapContainer: {
        width: '100%',
        height: 600
    }
  };

  export default styles;


// WEBPACK FOOTER //
// ./src/containers/maps/styles/GoogleMapLoadSinglePinStyles.js